export default __webpack_public_path__ + "90610e10a977281358bebe0d84e9b7cf.png";